import React from "react";
import { FaSquareFacebook, FaInstagram, FaLinkedin } from "react-icons/fa6";

const TopNavbar = () => {
  return (
    <div className="hidden md:block py-2 px-6 xl:px-28  bg-[#00112D] ">
      <div className="max-w-7xl mx-auto text-white hidden md:flex justify-between items-center text-sm md:text-base">
        <div className="flex gap-5">
          <a
            href="mailto:classeswebbocket@gmail.com"
            className="hover:underline"
          >
            classeswebbocket@gmail.com
          </a>
          <a href="tel:+91 9861934932" className="hover:underline">
            +91 9861934932
          </a>
          <a href="tel:7656081495" className="hover:underline">
            +91 76560 81495
          </a>
        </div>
        <div className="flex gap-5">
          <a
            href="https://www.facebook.com/people/web-bocket/100092634887675/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaSquareFacebook size={20} />
          </a>
          <a
            href="https://www.instagram.com/web_bocket_classes/?hl=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram size={20} />
          </a>
          <a
            href="https://in.linkedin.com/company/bocket-lamp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin size={20} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopNavbar;
